/**
 * FloorX Cinematic — FULL PAGE sticky-track engine
 * Matches assets/index.html timeline feel on Shopify.
 *
 * Shopify cannot reliably use ScrollTrigger pin:true (theme overflow/
 * transform on #MainContent). Instead:
 *   .fx-scene track  = scroll runway (200–300vh)
 *   .fx-scene__stage = CSS sticky 100vh
 *   ScrollTrigger    = scrub only (pin:false) against the TRACK
 *
 * Owns: Lenis, particles, hero intro, ALL section scrub timelines.
 * Do NOT load fx-hero-engine / fx-story-engine / fx-index-runtime with it.
 */
(function () {
  'use strict';

  if (window.__FX_CINEMATIC__) return;
  window.__FX_CINEMATIC__ = true;

  var ROOT_ID = 'fx-index-clone';
  var state = { camZ: 8, lightIntensity: 0.5, rotSpeed: 0.002 };
  var lenis = null;
  var heroIntroDone = false;

  function root() {
    return document.getElementById(ROOT_ID);
  }
  function q(sel, el) {
    return (el || document).querySelector(sel);
  }
  function qq(sel, el) {
    return Array.prototype.slice.call((el || document).querySelectorAll(sel));
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function waitGsap(cb) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') return cb();
    var n = 0;
    var id = setInterval(function () {
      n++;
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        clearInterval(id);
        cb();
      } else if (n > 150) {
        clearInterval(id);
        console.error('[FX Cinematic] GSAP missing — showing content without animations');
        try {
          forceShowAllContent(root());
        } catch (e0) {}
      }
    }, 40);
  }

  /* ── Pin-safe Shopify wrappers (overflow/transform break ST.pin) ── */
  function preparePinSafe() {
    document.documentElement.classList.add('fx-cinematic', 'fx-index-runtime');
    if (document.body) document.body.classList.add('fx-cinematic', 'fx-index-runtime');

    var list = [
      document.getElementById('MainContent'),
      document.querySelector('.content-for-layout'),
      document.querySelector('.shopify-section.section-fx-proto-home'),
      document.querySelector('.section-fx-proto-home'),
      root(),
      q('#app', root())
    ];
    list.forEach(function (el) {
      if (!el) return;
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('overflow-x', 'visible', 'important');
      el.style.setProperty('transform', 'none', 'important');
      el.style.setProperty('filter', 'none', 'important');
      el.style.setProperty('perspective', 'none', 'important');
      el.style.setProperty('contain', 'none', 'important');
    });
  }

  /**
   * Lenis — exact index.html config for smooth wheel + ST scrub.
   * duration 1.2 + scrub:1 = silky cinematic (index uses 1.0; slightly smoother here)
   */
  function initLenis() {
    if (typeof Lenis === 'undefined' || typeof gsap === 'undefined') {
      window.fxScrollTo = function (sel) {
        var el = typeof sel === 'string' ? document.querySelector(sel) : sel;
        if (!el) return;
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.pageYOffset - 50,
          behavior: 'smooth'
        });
      };
      return null;
    }
    try {
      /* Kill duplicate Lenis from any leftover runtime */
      if (window.lenis && typeof window.lenis.destroy === 'function') {
        try {
          window.lenis.destroy();
        } catch (e0) {}
      }

      lenis = new Lenis({
        duration: 1.35,
        easing: function (t) {
          return Math.min(1, 1.001 - Math.pow(2, -10 * t));
        },
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 0.85,
        touchMultiplier: 1.35,
        infinite: false
      });

      lenis.on('scroll', ScrollTrigger.update);

      /* Single RAF loop — Lenis + GSAP share ticker (index pattern) */
      gsap.ticker.add(function (time) {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);

      window.lenis = lenis;
      window.fxScrollTo = function (sel) {
        var el = typeof sel === 'string' ? document.querySelector(sel) : sel;
        if (!el) return;
        lenis.scrollTo(el, { offset: -40, duration: 1.4 });
      };
      return lenis;
    } catch (e) {
      console.warn('[FX Cinematic] Lenis failed', e);
      return null;
    }
  }

  /**
   * FLOORX dead-center · size fits viewport on mobile (no side clip).
   * Uses setProperty(..., 'important') so CSS !important clamp cannot win.
   * GSAP must never set x / xPercent — only y / yPercent for scrub.
   */
  function centerHeroTitle(title) {
    if (!title) return;
    var mobile = window.innerWidth <= 768;
    var vw = Math.max(window.innerWidth || 320, 320);

    title.style.position = 'absolute';
    title.style.left = '0';
    title.style.right = '0';
    title.style.width = '100%';
    title.style.maxWidth = '100%';
    title.style.margin = '0';
    title.style.boxSizing = 'border-box';
    title.style.display = 'flex';
    title.style.flexDirection = 'row';
    title.style.flexWrap = 'nowrap';
    title.style.justifyContent = 'center';
    title.style.alignItems = 'center';
    title.style.textAlign = 'center';
    title.style.whiteSpace = 'nowrap';
    title.style.overflow = 'visible';
    title.style.top = mobile ? '20%' : '28%';

    if (mobile) {
      var pad = 28; /* total horizontal breathing room */
      var usable = Math.max(vw - pad, 180);
      /*
        Syne 800 "FLOORX" is very wide (~0.62em average glyph + X margin).
        Divide by ~6.4 so all 6 glyphs + cyan X always fit.
      */
      var px = usable / 6.4;
      if (px < 34) px = 34;
      if (px > 72) px = 72;
      title.style.setProperty('font-size', px + 'px', 'important');
      title.style.setProperty('letter-spacing', '-0.06em', 'important');
      title.style.setProperty('padding', '0 14px', 'important');
      title.style.setProperty('line-height', '0.85', 'important');
    } else {
      title.style.removeProperty('font-size');
      title.style.removeProperty('letter-spacing');
      title.style.removeProperty('padding');
      title.style.removeProperty('line-height');
    }

    if (typeof gsap !== 'undefined') {
      gsap.set(title, {
        x: 0,
        xPercent: 0,
        force3D: true,
        clearProps: 'scale,scaleX,scaleY'
      });
    }

    /* Second pass: if still overflowing, scale down until it fits */
    if (mobile) {
      requestAnimationFrame(function () {
        try {
          var parentW = title.parentElement ? title.parentElement.clientWidth : vw;
          var maxW = Math.max(parentW - 20, 160);
          var tw = title.scrollWidth || title.offsetWidth || 0;
          if (tw > maxW && tw > 0) {
            var scale = maxW / tw;
            if (scale < 0.55) scale = 0.55;
            if (scale > 1) scale = 1;
            /* scale via font-size, not transform (GSAP uses transform for y scrub) */
            var cur = parseFloat(window.getComputedStyle(title).fontSize) || 48;
            title.style.setProperty('font-size', cur * scale + 'px', 'important');
          }
        } catch (eFit) {}
      });
    }
  }

  /**
   * Cyan particle field (index.html style) on any section canvas.
   * mode: 'fall' | 'rise' | 'drift'
   */
  function startSectionParticles(canvasId, mode, count, blur) {
    var canvas = q('#' + canvasId, root()) || document.getElementById(canvasId);
    if (!canvas || canvas.dataset.fxParticles === '1') return null;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;

    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
    canvas.dataset.fxParticles = '1';

    var parent = canvas.parentElement;
    var parts = [];
    var running = true;
    mode = mode || 'fall';
    count = count || 45;
    blur = typeof blur === 'number' ? blur : mode === 'fall' ? 8 : 5;

    function layout() {
      canvas.style.position = 'absolute';
      canvas.style.left = '0';
      canvas.style.top = '0';
      canvas.style.right = '0';
      canvas.style.bottom = '0';
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.style.zIndex = '2';
      canvas.style.pointerEvents = 'none';
      canvas.style.display = 'block';
      canvas.style.visibility = 'visible';
      canvas.style.opacity = '1';
    }

    function resize() {
      layout();
      var w = window.innerWidth;
      var h = window.innerHeight;
      if (parent) {
        var pr = parent.getBoundingClientRect();
        if (pr.width > 2) w = Math.round(pr.width);
        if (pr.height > 2) h = Math.round(pr.height);
        if (h < 80) h = window.innerHeight;
        if (w < 80) w = window.innerWidth;
      }
      if (w < 2) w = window.innerWidth || 1;
      if (h < 2) h = window.innerHeight || 1;
      canvas.width = w;
      canvas.height = h;
    }

    resize();

    function Particle() {
      this.x = Math.random() * canvas.width;
      this.y = Math.random() * canvas.height;
      this.size = Math.random() * 2 + 0.5;
      if (mode === 'rise') {
        this.speedY = Math.random() * 0.5 + 0.1;
        this.speedX = (Math.random() - 0.5) * 0.5;
        this.opacity = Math.random() * 0.4 + 0.12;
      } else if (mode === 'drift') {
        this.speedY = (Math.random() - 0.5) * 0.42;
        this.speedX = (Math.random() - 0.5) * 0.65;
        /* Brighter for Transformation ambient field */
        this.opacity = Math.random() * 0.55 + 0.18;
        this.size = Math.random() * 2.6 + 0.6;
      } else {
        /* fall — hero/story style */
        this.speedY = Math.random() * -0.5 - 0.15;
        this.speedX = (Math.random() - 0.5) * 0.45;
        this.opacity = Math.random() * 0.5 + 0.12;
      }
    }
    Particle.prototype.update = function () {
      this.y += this.speedY;
      this.x += this.speedX;
      if (mode === 'rise') {
        if (this.y > canvas.height) {
          this.y = 0;
          this.x = Math.random() * canvas.width;
        }
      } else if (mode === 'drift') {
        if (this.y < -4) this.y = canvas.height + 4;
        if (this.y > canvas.height + 4) this.y = -4;
        if (this.x < -4) this.x = canvas.width + 4;
        if (this.x > canvas.width + 4) this.x = -4;
      } else if (this.y < 0) {
        this.y = canvas.height;
        this.x = Math.random() * canvas.width;
      }
    };
    Particle.prototype.draw = function () {
      ctx.fillStyle = 'rgba(0, 184, 255, ' + this.opacity + ')';
      ctx.shadowBlur = blur;
      ctx.shadowColor = '#00B8FF';
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
      ctx.fill();
    };

    for (var i = 0; i < count; i++) parts.push(new Particle());

    function loop() {
      if (!running || !canvas.isConnected) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var j = 0; j < parts.length; j++) {
        parts[j].update();
        parts[j].draw();
      }
      requestAnimationFrame(loop);
    }
    loop();

    function onResize() {
      resize();
    }
    window.addEventListener('resize', onResize, { passive: true });
    setTimeout(onResize, 150);
    setTimeout(onResize, 600);

    return { resize: onResize, canvas: canvas };
  }

  function bootParticles() {
    /* Prefer fx-index-particles.js — same hero-style field on every section */
    if (window.__FX_PARTICLES_BOOTED__) return window.__FX_PARTICLE_SYSTEMS__ || [];
    window.__FX_PARTICLES_BOOTED__ = true;
    /* Fallback if legacy particles script did not load */
    var systems = [
      startSectionParticles('hero-particles', 'fall', 55, 8),
      startSectionParticles('story-canvas', 'fall', 50, 10),
      startSectionParticles('sim-particles', 'fall', 50, 8),
      startSectionParticles('commercial-particles', 'fall', 50, 8),
      startSectionParticles('stats-particles', 'fall', 50, 8),
      startSectionParticles('materials-particles', 'fall', 50, 8),
      startSectionParticles('shop-particles', 'fall', 50, 8)
    ].filter(Boolean);
    window.__FX_PARTICLE_SYSTEMS__ = systems;
    console.info('[FX] particles fallback (all sections, hero-style)', systems.length);
    return systems;
  }

  /* ── Hero intro — EXACT index.html (safe if already visible) ── */
  function heroIntro(r) {
    var title = q('#hero-title', r);
    var letterX = q('.hero-letter-x', r);
    var left = q('.hero-left', r);
    var right = q('.hero-right', r);
    var particlesEl = q('#hero-particles', r);
    var overlay = q('#hero-overlay', r) || q('.hero-overlay', r);
    var mobile = window.innerWidth <= 768;

    centerHeroTitle(title);

    /* Ensure everything ends visible even if timeline is skipped */
    function finishVisible() {
      heroIntroDone = true;
      centerHeroTitle(title);
      if (title) gsap.set(title, { opacity: 1, y: 0, yPercent: 0, x: 0, xPercent: 0 });
      if (particlesEl) gsap.set(particlesEl, { opacity: 1 });
      /* Mobile: left panel holds CTA — must stay visible */
      if (left) gsap.set(left, { opacity: 1, x: 0, clearProps: mobile ? 'transform' : '' });
      if (right && !mobile) gsap.set(right, { opacity: 1, x: 0 });
      if (right && mobile) gsap.set(right, { opacity: 0, clearProps: 'transform' });
      if (overlay) gsap.set(overlay, { opacity: 1 });
    }

    var tl = gsap.timeline({
      defaults: { ease: 'power4.out' },
      onComplete: finishVisible
    });

    if (particlesEl) {
      tl.fromTo(particlesEl, { opacity: 0.2 }, { opacity: 1, duration: 1.5 }, 0);
    }
    if (title) {
      tl.fromTo(
        title,
        { opacity: 0, y: 80, x: 0, xPercent: 0 },
        { opacity: 1, y: 0, x: 0, xPercent: 0, duration: 1.4, force3D: true },
        0.5
      );
    }
    if (letterX) {
      tl.fromTo(
        letterX,
        { textShadow: '0 0 0px #00B8FF' },
        {
          textShadow: '0 0 40px #00B8FF, 0 0 80px #00B8FF',
          duration: 0.8,
          yoyo: true,
          repeat: 1,
          ease: 'power2.inOut'
        },
        '-=0.5'
      );
    }
    if (left && !mobile) {
      tl.fromTo(left, { opacity: 0, x: -50 }, { opacity: 1, x: 0, duration: 1.5 }, 1);
    } else if (left && mobile) {
      /* Mobile: fade up CTA stack under FLOORX (no side slide) */
      tl.fromTo(left, { opacity: 0, y: 28 }, { opacity: 1, y: 0, duration: 1.1 }, 1);
    }
    if (right && !mobile) {
      tl.fromTo(right, { opacity: 0, x: 50 }, { opacity: 1, x: 0, duration: 1.5 }, 1);
    }
    if (overlay) gsap.set(overlay, { opacity: 1 });

    /* Hard failsafe — never leave text blank */
    setTimeout(finishVisible, 2500);
  }

  /**
   * Failsafe: only hero chrome if intro never finished.
   * NEVER force story/sim/shop scrub targets — that kills word-by-word cinema.
   */
  function forceShowHeroOnly(r) {
    if (!r) return;
    var title = q('#hero-title', r);
    var left = q('.hero-left', r);
    var right = q('.hero-right', r);
    var particlesEl = q('#hero-particles', r);
    var overlay = q('#hero-overlay', r);
    var bg = q('#hero-bg', r);
    var fog = q('#hero-fog', r);
    if (typeof gsap !== 'undefined') {
      var isMobile = window.innerWidth <= 768;
      if (title) gsap.set(title, { opacity: 1, y: 0, yPercent: 0, x: 0, xPercent: 0 });
      if (left) gsap.set(left, { opacity: 1, x: 0, y: 0 });
      if (right) gsap.set(right, { opacity: isMobile ? 0 : 1, x: 0 });
      if (particlesEl) gsap.set(particlesEl, { opacity: 1 });
      if (overlay) gsap.set(overlay, { opacity: 1 });
      if (bg) gsap.set(bg, { opacity: 1 });
      if (fog) gsap.set(fog, { opacity: 1 });
      centerHeroTitle(title);
    } else {
      [title, left, right, particlesEl, overlay, bg, fog].forEach(function (el) {
        if (!el) return;
        el.style.opacity = '1';
        el.style.visibility = 'visible';
      });
    }
  }

  /** Full page only when GSAP is totally missing */
  function forceShowAllContent(r) {
    forceShowHeroOnly(r);
    if (!r) return;
    qq(
      '.story-eyebrow, #story-paragraph, #story-cta, #story-text .word, .sim-elem, .commercial-eyebrow, .commercial-title, .commercial-card, .stat-card, .mat-eyebrow, .mat-title, .mat-frame, .shop-title, .shop-sub, .shop-product',
      r
    ).forEach(function (el) {
      el.style.opacity = '1';
      el.style.visibility = 'visible';
      el.style.filter = 'none';
    });
  }

  /* ── Before/after slider ── */
  function initSlider(r) {
    var box = q('#slider-container', r);
    var handle = q('#drag-handle', r);
    var after = q('#after-wrapper', r);
    if (!box || !handle || !after) return;
    var drag = false;
    function setPos(cx) {
      var rect = box.getBoundingClientRect();
      var x = Math.min(Math.max(cx - rect.left, 0), rect.width);
      var pct = (x / rect.width) * 100;
      handle.style.left = pct + '%';
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
    }
    box.addEventListener('mousedown', function (e) {
      drag = true;
      e.preventDefault();
      setPos(e.clientX);
    });
    window.addEventListener('mousemove', function (e) {
      if (drag) setPos(e.clientX);
    });
    window.addEventListener('mouseup', function () {
      drag = false;
    });
    box.addEventListener(
      'touchstart',
      function (e) {
        drag = true;
        setPos(e.touches[0].clientX);
      },
      { passive: true }
    );
    window.addEventListener(
      'touchmove',
      function (e) {
        if (!drag) return;
        setPos(e.touches[0].clientX);
      },
      { passive: true }
    );
    window.addEventListener('touchend', function () {
      drag = false;
    });
  }

  /* ── Magnetic buttons ── */
  function initMagnetic(r) {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    qq('.magnetic-btn', r).forEach(function (btn) {
      if (btn.dataset.mag === '1') return;
      btn.dataset.mag = '1';
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        gsap.to(btn, { x: x * 0.2, y: y * 0.2, duration: 0.3 });
      });
      btn.addEventListener('mouseleave', function () {
        gsap.to(btn, { x: 0, y: 0, duration: 0.45 });
      });
    });
  }

  /* ── AJAX ATC — real Shopify cart/add + open cart drawer ── */
  var atcBusy = false;

  function cartAddUrl() {
    if (window.routes && window.routes.cart_add_url) {
      return String(window.routes.cart_add_url).replace(/\.js$/, '') + '.js';
    }
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart/add.js';
  }

  function cartJsUrl() {
    if (window.routes && window.routes.cart_url) {
      return String(window.routes.cart_url).replace(/\.js$/, '') + '.js';
    }
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function openCartDrawer(btn) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.open(btn || null);
        return true;
      } catch (e0) {}
    }
    var icon = document.querySelector('#cart-icon-bubble, a.header__icon--cart, .header__icon--cart');
    if (icon) {
      icon.click();
      return true;
    }
    return false;
  }

  function updateCartBubble(count) {
    if (typeof count !== 'number') return;
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    link.dataset.cartCount = String(count);
    var bubble = link.querySelector('.cart-count-bubble');
    if (count <= 0) {
      if (bubble) bubble.remove();
      return;
    }
    var label = count > 99 ? '99+' : String(count);
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      link.appendChild(bubble);
    }
    bubble.dataset.cartCount = String(count);
    bubble.innerHTML =
      '<span aria-hidden="true">' +
      label +
      '</span><span class="visually-hidden">' +
      count +
      ' items in cart</span>';
  }

  function initAtc(r) {
    var scope = r || root() || document;
    qq('.fx-index-atc', scope).forEach(function (btn) {
      if (btn.dataset.atcBound === '1') return;
      btn.dataset.atcBound = '1';
      btn.style.pointerEvents = 'auto';
      btn.style.cursor = 'pointer';
      btn.setAttribute('type', 'button');

      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (atcBusy || btn.disabled) return;

          var rawId = btn.getAttribute('data-variant-id') || btn.dataset.variantId || '';
          var variantId = parseInt(String(rawId).replace(/[^\d]/g, ''), 10);
          var fallbackUrl = btn.getAttribute('data-product-url') || btn.dataset.productUrl || '';

          if (!variantId) {
            console.warn('[FX ATC] missing variant id', btn);
            if (fallbackUrl) window.location.href = fallbackUrl;
            return;
          }

          atcBusy = true;
          var original = btn.textContent;
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          btn.textContent = 'Adding…';

          var body = {
            items: [{ id: variantId, quantity: 1 }]
          };

          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            try {
              body.sections = drawer.getSectionsToRender().map(function (s) {
                return s.id;
              });
              body.sections_url = window.location.pathname;
            } catch (e1) {}
          } else {
            body.sections = 'cart-drawer,cart-icon-bubble';
            body.sections_url = window.location.pathname;
          }

          fetch(cartAddUrl(), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(body)
          })
            .then(function (res) {
              return res.json().then(function (data) {
                return { ok: res.ok, status: res.status, data: data || {} };
              });
            })
            .then(function (result) {
              var data = result.data;
              if (!result.ok || data.status || data.message === 'Cart Error') {
                var msg = data.description || data.message || 'Could not add to cart';
                console.warn('[FX ATC] failed', data);
                btn.textContent = 'Error';
                setTimeout(function () {
                  btn.textContent = original;
                }, 1600);
                return;
              }

              btn.textContent = 'Added ✓';

              /* Update drawer HTML when sections returned */
              if (drawer && data.sections && typeof drawer.renderContents === 'function') {
                try {
                  drawer.classList.remove('is-empty');
                  drawer.renderContents(data);
                } catch (e2) {
                  openCartDrawer(btn);
                }
              } else {
                openCartDrawer(btn);
              }

              /* Sync count from cart.js */
              fetch(cartJsUrl(), {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' }
              })
                .then(function (r) {
                  return r.json();
                })
                .then(function (cart) {
                  updateCartBubble(cart.item_count || 0);
                })
                .catch(function () {});

              try {
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
                document.dispatchEvent(new CustomEvent('cart:refresh'));
              } catch (e3) {}

              setTimeout(function () {
                btn.textContent = original;
              }, 1800);
            })
            .catch(function (err) {
              console.error('[FX ATC] network', err);
              btn.textContent = 'Error';
              setTimeout(function () {
                btn.textContent = original;
                if (fallbackUrl) window.location.href = fallbackUrl;
              }, 1200);
            })
            .finally(function () {
              atcBusy = false;
              btn.disabled = false;
              btn.removeAttribute('aria-busy');
            });
        },
        true
      );
    });
  }

  /**
   * Full-page scroll animations against sticky scene tracks.
   * trigger = .fx-scene track · stage sticks via CSS · scrub only (no pin)
   */
  function initScrollAnimations(r) {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });
    preparePinSafe();

    ScrollTrigger.getAll().forEach(function (t) {
      try {
        t.kill(true);
      } catch (e) {
        t.kill();
      }
    });

    /* Silkier scrub with Lenis (index uses 1; 1.15 feels smoother on Shopify) */
    var SCRUB = 1.15;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) SCRUB = true; /* instant scrub when motion reduced */

    /** Resolve scene track for a stage id (hero/story/sim/…) */
    function sceneTrack(name) {
      return (
        q('.fx-scene--' + name, r) ||
        q('[data-fx-scene="' + name + '"]', r) ||
        q('#' + name, r)
      );
    }

    /**
     * Scrub config — pin:false (CSS sticky owns stickiness)
     * start/end against the tall track = same feel as index pin end:+=N%
     */
    function trackCfg(id, track, extra) {
      var cfg = {
        id: id,
        trigger: track,
        start: 'top top',
        end: 'bottom bottom',
        scrub: SCRUB,
        pin: false,
        pinSpacing: false,
        anticipatePin: 0,
        invalidateOnRefresh: true,
        fastScrollEnd: true
      };
      if (extra) {
        Object.keys(extra).forEach(function (k) {
          cfg[k] = extra[k];
        });
      }
      return cfg;
    }

    /* ── HERO (track · scrub fade — MUST reverse on scroll up like index) ──
       Never gsap.set(opacity:0) in onLeave — that permanently kills reverse. */
    var heroTrack = sceneTrack('hero');
    var hero = q('#hero', r);
    var heroTitle = q('#hero-title', r);
    if (heroTrack && hero) {
      centerHeroTitle(heroTitle);

      var heroOverlay = q('#hero-overlay', r) || q('.hero-overlay', r);
      var heroParticles = q('#hero-particles', r);
      var heroBg = q('#hero-bg', r);
      var heroFog = q('#hero-fog', r);
      var heroBgImgs = heroBg ? heroBg.querySelectorAll('img') : [];

      /* Keep images decoded/eager so reverse scroll never hits empty bitmaps */
      if (heroBgImgs && heroBgImgs.length) {
        heroBgImgs.forEach(function (img) {
          try {
            img.loading = 'eager';
            img.decoding = 'async';
            img.setAttribute('fetchpriority', 'high');
            if (typeof img.decode === 'function') {
              img.decode().catch(function () {});
            }
          } catch (eImg) {}
        });
      }

      /* Baseline — bg fully on; intro owns title/particles entrance */
      if (heroBg) gsap.set(heroBg, { opacity: 1, force3D: true });
      if (heroFog) gsap.set(heroFog, { opacity: 1 });

      function restoreHeroFull() {
        if (heroBg) gsap.set(heroBg, { opacity: 1 });
        if (heroFog) gsap.set(heroFog, { opacity: 1 });
        if (heroOverlay) gsap.set(heroOverlay, { opacity: 1 });
        if (heroParticles) gsap.set(heroParticles, { opacity: 1 });
        if (heroTitle) {
          centerHeroTitle(heroTitle);
          gsap.set(heroTitle, {
            opacity: 1,
            yPercent: 0,
            y: 0,
            x: 0,
            xPercent: 0
          });
        }
        var left = q('.hero-left', hero);
        var right = q('.hero-right', hero);
        if (left) gsap.set(left, { opacity: 1, x: 0 });
        if (right) gsap.set(right, { opacity: 1, x: 0 });
      }

      var heroST = trackCfg('fx-hero', heroTrack, {
        onRefresh: function () {
          centerHeroTitle(heroTitle);
        },
        onUpdate: function (self) {
          if (heroIntroDone && self.direction === -1 && self.progress <= 0.001) {
            restoreHeroFull();
          }
        },
        onEnterBack: function () {
          centerHeroTitle(heroTitle);
        }
      });

      var heroTl = gsap.timeline({
        defaults: { ease: 'none', immediateRender: false },
        scrollTrigger: heroST
      });

      /*
        EXACT index.html hero scrub:
        .to("#hero-title", { yPercent: -20 }, 0)
        .to(".hero-overlay", { opacity: 0 }, 0)
        .to("#hero-particles", { opacity: 0 }, 0)
        .to("#hero-bg", { opacity: 0 }, 0)
      */
      if (heroTitle) {
        heroTl.fromTo(
          heroTitle,
          { yPercent: 0, x: 0, xPercent: 0 },
          { yPercent: -20, x: 0, xPercent: 0, force3D: true, duration: 1 },
          0
        );
      }
      if (heroOverlay) {
        heroTl.fromTo(heroOverlay, { opacity: 1 }, { opacity: 0, duration: 1 }, 0);
      }
      if (heroParticles) {
        heroTl.fromTo(heroParticles, { opacity: 1 }, { opacity: 0, duration: 1 }, 0);
      }
      if (heroBg) {
        heroTl.fromTo(heroBg, { opacity: 1 }, { opacity: 0, duration: 1 }, 0);
      }
      if (heroFog) {
        heroTl.fromTo(heroFog, { opacity: 1 }, { opacity: 0, duration: 1 }, 0);
      }
    }

    /* ── STORY — EXACT index.html word-by-word (pin end:+=200% → track 300vh) ── */
    var storyTrack = sceneTrack('story');
    var story = q('#story', r);
    var storyText = q('#story-text', r);
    if (storyTrack && story && storyText) {
      var words = gsap.utils.toArray(storyText.querySelectorAll('.word'));
      var eyebrow = q('.story-eyebrow', story);
      var paragraph = q('#story-paragraph', r) || q('#story-paragraph', story);
      var cta = q('#story-cta', r) || q('#story-cta', story);

      if (words.length > 0) {
        /* Pre-split .word = index SplitType output */
        words.forEach(function (w) {
          w.style.display = 'inline-block';
          w.style.visibility = 'visible';
          w.classList.remove('opacity-0');
        });
        if (eyebrow) {
          eyebrow.classList.remove('opacity-0');
          eyebrow.style.visibility = 'visible';
        }
        if (paragraph) {
          paragraph.classList.remove('opacity-0');
          paragraph.style.visibility = 'visible';
        }
        if (cta) {
          cta.classList.remove('opacity-0');
          cta.style.visibility = 'visible';
        }

        /* EXACT index set — words start hidden for scrub reveal */
        gsap.set(words, {
          opacity: 0,
          y: 80,
          scale: 0.9,
          rotateX: 25,
          filter: 'blur(20px)',
          transformPerspective: 1000,
          force3D: true,
          color: '#FFFFFF'
        });
        if (eyebrow) gsap.set(eyebrow, { opacity: 0, y: 20 });
        if (paragraph) gsap.set(paragraph, { opacity: 0, y: 30 });
        if (cta) gsap.set(cta, { opacity: 0, y: 30 });

        /*
          index: trigger #story, start top top, end +=200%, scrub:1, pin:true
          Shopify sticky track is 300vh → scrub start top top / end bottom bottom
        */
        var storyST = {
          id: 'fx-story',
          trigger: storyTrack,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 1,
          pin: false,
          pinSpacing: false,
          anticipatePin: 0,
          invalidateOnRefresh: true,
          fastScrollEnd: true
        };

        var storyTl = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: storyST
        });

        /* EXACT index timeline positions & durations */
        if (eyebrow) {
          storyTl.to(eyebrow, { opacity: 1, y: 0, duration: 10 }, 0);
        }

        function wordBeat(i, at) {
          if (!words[i]) return;
          storyTl.to(
            words[i],
            {
              opacity: 1,
              y: 0,
              scale: 1,
              rotateX: 0,
              filter: 'blur(0px)',
              color: '#009CFF',
              duration: 5,
              ease: 'power3.out'
            },
            at
          );
          /* cyan → white settle (index) */
          storyTl.to(words[i], { color: '#FFFFFF', duration: 2 }, at + 5);
        }

        /* index: Engineered(0) for(1) Commercial(2) &(3) Home(4) Gyms(5) */
        wordBeat(0, 10);
        wordBeat(1, 20);
        wordBeat(2, 35);
        wordBeat(3, 45);
        wordBeat(4, 60);
        wordBeat(5, 75);

        if (paragraph) storyTl.to(paragraph, { opacity: 1, y: 0, duration: 5 }, 90);
        if (cta) storyTl.to(cta, { opacity: 1, y: 0, duration: 5 }, 95);

        console.info('[FX] story word scrub armed', words.length, 'words');
      }
    }

    /* ── SIM (track · stagger reveal + before/after) ── */
    var simTrack = sceneTrack('sim');
    var sim = q('#sim', r);
    if (simTrack && sim) {
      /* Animate .sim-anim only — never layout wrappers (.sim-stage / .sim-copy / .sim-slider-wrap) */
      var simElems = gsap.utils.toArray(sim.querySelectorAll('.sim-anim'));
      if (!simElems.length) {
        simElems = gsap.utils.toArray(sim.querySelectorAll('.sim-elem'));
      }
      /*
        Fade only — no x/y/scale transforms.
        Transforms create stacking contexts that can make title appear under the compare image.
      */
      gsap.set(simElems, {
        opacity: 0,
        filter: 'blur(6px)',
        x: 0,
        y: 0,
        clearProps: 'left,right,top,bottom,position,transform'
      });
      gsap
        .timeline({
          defaults: { ease: 'none' },
          scrollTrigger: trackCfg('fx-sim', simTrack, {
            onLeave: function () {
              gsap.set(simElems, { opacity: 1, filter: 'blur(0px)', x: 0, y: 0 });
            }
          })
        })
        .to(
          simElems,
          {
            opacity: 1,
            filter: 'blur(0px)',
            x: 0,
            y: 0,
            stagger: 10,
            duration: 16
          },
          0
        )
        .to({}, { duration: 10 });
    }

    /* ── COMMERCIAL (desktop: horizontal scrub · mobile: vertical stack stagger) ── */
    var commercialTrack = sceneTrack('commercial');
    var commercial = q('#commercial', r);
    var cardsContainer = q('#h-scroll', r);
    if (commercialTrack && commercial && cardsContainer) {
      var cards = gsap.utils.toArray(commercial.querySelectorAll('.commercial-card'));
      var comEyebrow = q('.commercial-eyebrow', commercial);
      var comTitle = q('.commercial-title', commercial);
      var isMobileCom = window.innerWidth <= 768;

      function getScrollAmount() {
        if (!cards.length) return 0;
        var totalWidth = cardsContainer.scrollWidth;
        var maxScroll = totalWidth - window.innerWidth + (window.innerWidth * 0.1);
        return maxScroll > 0 ? maxScroll : 0;
      }

      if (comEyebrow) gsap.set(comEyebrow, { opacity: 0, y: 20 });
      if (comTitle) gsap.set(comTitle, { opacity: 0, y: 30 });
      gsap.set(cardsContainer, { x: 0, clearProps: isMobileCom ? 'transform' : '' });

      if (isMobileCom) {
        /* Steps 01–05 stacked vertically — same cinematic fade/rise style */
        if (cards.length) gsap.set(cards, { opacity: 0, y: 48 });
        var commercialMobileTl = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            id: 'fx-commercial-mobile',
            trigger: commercial,
            start: 'top 78%',
            end: 'bottom 55%',
            scrub: SCRUB,
            invalidateOnRefresh: true,
            onLeave: function () {
              if (comEyebrow) gsap.set(comEyebrow, { opacity: 1, y: 0 });
              if (comTitle) gsap.set(comTitle, { opacity: 1, y: 0 });
              if (cards.length) gsap.set(cards, { opacity: 1, y: 0 });
            }
          }
        });
        if (comEyebrow) commercialMobileTl.to(comEyebrow, { opacity: 1, y: 0, duration: 8 }, 0);
        if (comTitle) commercialMobileTl.to(comTitle, { opacity: 1, y: 0, duration: 8 }, 4);
        if (cards.length) {
          commercialMobileTl.to(
            cards,
            {
              opacity: 1,
              y: 0,
              stagger: 10,
              duration: 14
            },
            10
          );
        }
        commercialMobileTl.to({}, { duration: 8 });
      } else {
        /* Desktop: horizontal Apple-style scrub */
        if (cards.length) gsap.set(cards, { opacity: 1, y: 0 });
        var commercialTl = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: trackCfg('fx-commercial', commercialTrack)
        });
        if (comEyebrow) commercialTl.to(comEyebrow, { opacity: 1, y: 0, duration: 6 }, 0);
        if (comTitle) commercialTl.to(comTitle, { opacity: 1, y: 0, duration: 6 }, 2);
        commercialTl.to(
          cardsContainer,
          {
            x: function () {
              var isRtl = cardsContainer.getAttribute('dir') === 'rtl' || document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
              return isRtl ? getScrollAmount() : -getScrollAmount();
            },
            ease: 'none',
            duration: 70
          },
          8
        );
      }
    }

    /* ── STATS (scroll reveal) ── */
    var statsTrack = sceneTrack('stats');
    var stats = q('#stats', r);
    if (stats) {
      var statCards = gsap.utils.toArray(stats.querySelectorAll('.stat-card'));
      gsap.set(statCards, { opacity: 0, y: 40 });
      var statsCounted = false;
      function runStatCounters() {
        if (statsCounted) return;
        statsCounted = true;
        statCards.forEach(function (card) {
          var counter = card.querySelector('.stat-counter');
          if (!counter || counter.dataset.done === '1') return;
          counter.dataset.done = '1';
          var target = parseInt(counter.getAttribute('data-target'), 10) || 0;
          var obj = { n: 0 };
          gsap.to(obj, {
            n: target,
            duration: 1.8,
            ease: 'power2.out',
            onUpdate: function () {
              counter.textContent = Math.ceil(obj.n) + '+';
            }
          });
        });
      }
      gsap
        .timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            id: 'fx-stats',
            trigger: statsTrack || stats,
            start: 'top 85%',
            end: 'center 55%',
            scrub: SCRUB,
            invalidateOnRefresh: true,
            onEnter: runStatCounters,
            onEnterBack: runStatCounters
          }
        })
        .to(statCards, {
          opacity: 1,
          y: 0,
          stagger: 0.35,
          duration: 1.2
        });
    }

    /* ── MATERIALS (track · reveal + bottle lift) ── */
    var materialsTrack = sceneTrack('materials');
    var materials = q('#materials', r);
    if (materialsTrack && materials) {
      var matEyebrow = q('.mat-eyebrow', materials);
      var matTitle = q('.mat-title', materials);
      var matFrame = q('.mat-frame', materials);
      var matBottle = q('#mat-bottle-img', materials);
      if (matEyebrow) gsap.set(matEyebrow, { opacity: 0, y: 20 });
      if (matTitle) gsap.set(matTitle, { opacity: 0, y: 40 });
      if (matFrame) gsap.set(matFrame, { opacity: 0, y: 60, scale: 0.95 });
      /* Bottle stays centered — animate opacity/scale only (no x shift) */
      if (matBottle) gsap.set(matBottle, { y: 18, scale: 0.96, x: 0, xPercent: 0, left: 'auto', right: 'auto' });
      var matTl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: trackCfg('fx-materials', materialsTrack, {
          onLeave: function () {
            if (matEyebrow) gsap.set(matEyebrow, { opacity: 1, y: 0 });
            if (matTitle) gsap.set(matTitle, { opacity: 1, y: 0 });
            if (matFrame) gsap.set(matFrame, { opacity: 1, y: 0, scale: 1 });
            if (matBottle) gsap.set(matBottle, { y: 0, scale: 1, x: 0, xPercent: 0 });
          }
        })
      });
      matTl.to(state, { camZ: 5, duration: 10 }, 0);
      matTl.to(state, { rotSpeed: 0.01, duration: 10 }, 20);
      matTl.to(state, { lightIntensity: 2.5, duration: 10 }, 35);
      if (matEyebrow) matTl.to(matEyebrow, { opacity: 1, y: 0, duration: 5 }, 8);
      if (matTitle) matTl.to(matTitle, { opacity: 1, y: 0, duration: 5 }, 12);
      if (matFrame) matTl.to(matFrame, { opacity: 1, y: 0, scale: 1, duration: 12 }, 16);
      if (matBottle) matTl.to(matBottle, { y: 0, scale: 1, x: 0, xPercent: 0, duration: 14 }, 18);
      matTl.to({}, { duration: 10 }, 40);
    }

    /* ── SHOP (scroll reveal) ── */
    var shopTrack = sceneTrack('shop');
    var shop = q('#shop', r);
    if (shop) {
      var shopTitle = q('.shop-title', shop);
      var shopSub = q('.shop-sub', shop);
      var shopProducts = gsap.utils.toArray(shop.querySelectorAll('.shop-product'));
      if (shopTitle) gsap.set(shopTitle, { opacity: 0, y: 36 });
      if (shopSub) gsap.set(shopSub, { opacity: 0, y: 24 });
      if (shopProducts.length) gsap.set(shopProducts, { opacity: 0, y: 72, scale: 0.94 });
      var shopTl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          id: 'fx-shop',
          trigger: shopTrack || shop,
          start: 'top 78%',
          end: 'center 48%',
          scrub: SCRUB,
          invalidateOnRefresh: true,
          onLeave: function () {
            if (shopTitle) gsap.set(shopTitle, { opacity: 1, y: 0 });
            if (shopSub) gsap.set(shopSub, { opacity: 1, y: 0 });
            if (shopProducts.length) gsap.set(shopProducts, { opacity: 1, y: 0, scale: 1 });
          },
          onEnter: function () {
            /* if scrub stuck, still show when section is entered */
          }
        }
      });
      if (shopTitle) shopTl.to(shopTitle, { opacity: 1, y: 0, duration: 2 });
      if (shopSub) shopTl.to(shopSub, { opacity: 1, y: 0, duration: 2 }, '-=1.4');
      if (shopProducts.length) {
        shopTl.to(
          shopProducts,
          { opacity: 1, y: 0, scale: 1, stagger: 1.2, duration: 2.8, ease: 'power3.out' },
          '-=1'
        );
      }
    }

    console.info(
      '[FX Cinematic] full page sticky-tracks armed',
      ScrollTrigger.getAll().length,
      'triggers',
      lenis ? '+Lenis' : '+native'
    );
  }

  function boot() {
    var r = root();
    if (!r) {
      console.warn('[FX Cinematic] #fx-index-clone missing');
      return;
    }

    /* 1) Particles FIRST — exact index, no GSAP required */
    var particleSystems = bootParticles();

    /* 2) ATC must work even if GSAP never loads */
    initAtc(r);
    setTimeout(function () {
      initAtc(r);
    }, 400);

    /* Hero-only failsafe — never touch story word scrub */
    setTimeout(function () {
      if (!heroIntroDone) forceShowHeroOnly(r);
    }, 2800);

    waitGsap(function () {
      try {
        gsap.registerPlugin(ScrollTrigger);
        preparePinSafe();

        var hbBoot = q('#hero-bg', r);
        var hfBoot = q('#hero-fog', r);
        if (hbBoot) {
          gsap.set(hbBoot, { opacity: 1, visibility: 'visible' });
          hbBoot.style.opacity = '1';
        }
        if (hfBoot) gsap.set(hfBoot, { opacity: 1 });

        initLenis();
        heroIntro(r);
        initSlider(r);
        initMagnetic(r);
        initAtc(r);
        initScrollAnimations(r);

        document.documentElement.classList.add('fx-cinematic-ready');

        function refresh() {
          preparePinSafe();
          centerHeroTitle(q('#hero-title', r));
          particleSystems = window.__FX_PARTICLE_SYSTEMS__ || particleSystems;
          if (particleSystems && particleSystems.forEach) {
            particleSystems.forEach(function (sys) {
              if (sys && typeof sys.resize === 'function') sys.resize();
            });
          }
          if (window.scrollY < 80) {
            var hb = q('#hero-bg', r);
            var hf = q('#hero-fog', r);
            var hp = q('#hero-particles', r);
            if (hb) {
              gsap.set(hb, { opacity: 1 });
              hb.style.opacity = '1';
            }
            if (hf) gsap.set(hf, { opacity: 1 });
            if (hp) {
              gsap.set(hp, { opacity: 1 });
              hp.style.opacity = '1';
            }
          }
          try {
            ScrollTrigger.refresh(true);
          } catch (e) {}
        }
        requestAnimationFrame(refresh);
        setTimeout(refresh, 200);
        setTimeout(refresh, 800);
        setTimeout(refresh, 1600);
        window.addEventListener('load', refresh, { once: true });
        window.addEventListener(
          'resize',
          function () {
            clearTimeout(window.__fxCinResize);
            window.__fxCinResize = setTimeout(refresh, 150);
          },
          { passive: true }
        );
      } catch (err) {
        console.error('[FX Cinematic] boot failed', err);
        forceShowAllContent(r);
      }
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function () {
    window.__FX_CINEMATIC__ = false;
    setTimeout(function () {
      window.__FX_CINEMATIC__ = true;
      boot();
    }, 80);
  });

  window.FXCinematic = { reboot: boot, state: state };
})();
